import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { SharedModule } from "src/app/shared/shared.module";
import { SensorComponent } from "./sensorview/sensorview";

@NgModule({
    imports: [
        BrowserModule,
        SharedModule,
    ],
    declarations: [
        SensorComponent,
    ],
    exports: [
        SensorComponent,
    ],
})
export class Common_Sensor { }
